import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import type {
  AssignmentHasBeenPeerReviewedMessageNotification as AssignmentHasBeenPeerReviewedMessageNotificationType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: AssignmentHasBeenPeerReviewedMessageNotificationType;
  rank?: number;
  onClick: (notification: NotificationType) => void;
};

const AssignmentHasBeenPeerReviewedMessageNotification = ({
  notification,
  rank,
  onClick,
  notification: {
    data: { redirectUrlOnClick, item },
  },
}: Props) => (
  <Notification onClick={onClick} href={redirectUrlOnClick} notification={notification} rank={rank}>
    <FormattedHTMLMessage
      message={_t(`Your assignment {assignmentName} has been reviewed`)}
      assignmentName={item.title}
      tagName="span"
    />
  </Notification>
);

export default AssignmentHasBeenPeerReviewedMessageNotification;
